import { Action, Actions, Dispatch, State } from "./types";

export function Reducer(state: State, action: Action) {
  switch (action.type) {
    case "ADD_ITEMS_TO_CART": {
      return {
        ...state,
        latestAddedCartItems: action.items,
      };
    }
    case "RESET_LAST_ADDED_ITEMS": {
      return {
        ...state,
        latestAddedCartItems: [],
      };
    }
    case "ADD_OTC_REJECT_ITEMS": {
      return {
        ...state,
        addOtcRejectItems: action.items,
      };
    }
    case "RESET_OTC_REJECT_ITEMS": {
      return {
        ...state,
        addOtcRejectItems: [],
      };
    }
    case "ADD_OUT_OF_STOCK_REJECT_ITEMS": {
      return {
        ...state,
        addOutOfStockRejectItems: action.items,
      };
    }
    case "RESET_OUT_OF_STOCK_REJECT_ITEMS": {
      return {
        ...state,
        addOutOfStockRejectItems: [],
      };
    }
    default: {
      throw new Error("AppContext - Unhandled action type");
    }
  }
}

export function mapToReducerActions(dispatch: Dispatch): Actions {
  return {
    addItemsToCart: (items: any[]) =>
      dispatch({ type: "ADD_ITEMS_TO_CART", items }),
    resetLastAddedItems() {
      dispatch({ type: "RESET_LAST_ADDED_ITEMS" });
    },
    addOtcRejectItems: (items: any[]) =>
      dispatch({ type: "ADD_OTC_REJECT_ITEMS", items }),
    resetOtcRejectItems() {
      dispatch({ type: "RESET_OTC_REJECT_ITEMS" });
    },
    addOutOfStockRejectItems: (items: any[]) =>
      dispatch({ type: "ADD_OUT_OF_STOCK_REJECT_ITEMS", items }),
    resetOutOfStockRejectItems() {
      dispatch({ type: "RESET_OUT_OF_STOCK_REJECT_ITEMS" });
    },
  };
}
